import Flux from '../flux';
var webRoot = window.location.protocol + "//" + window.location.hostname + "/Cention/web/";

export default Flux.createActions({
	loadAllAddressbooks: function() {
		return function(dispatch) {
			dispatch();

			this.loadGlobalPersonalAddressbook()
				.then(result => {
				})
				.catch(error => {
					// Handle failure
					dispatch({
						type: 'SET_ERROR',
						payload: {
							type: 'globalPersonal',
							error: error.message || 'Failed to load personal addressbook'
						}
					});
				});
		}.bind(this);
	},

	loadGlobalPersonalAddressbook: function() {
		return new Promise((resolve, reject) => {
			const url = webRoot + 'admin/globalAddressbook/list';
			const params = { personal: 1, searchText: '' };
			
			$.post(url, params)
				.done((data) => {
					this.setGlobalPersonalAddressbook(data);
					resolve(data);
				})
				.fail((error) => {
					console.error('[AddressbookActions] Failed to load personal addressbook:', error);
					this.setError({
						type: 'globalPersonal',
						error: error.responseText || 'Failed to load personal addressbook'
					});
					reject(error);
				});
		});
	},

	setGlobalPersonalAddressbook: function(data) {
		return function(dispatch) {
			dispatch(data);
		};
	},

	setLoadingStatus: function(status) {
		return function(dispatch) {
			dispatch(status);
		};
	},

	setError: function(error) {
		return function(dispatch) {
			dispatch(error);
		};
	},

	logActivity: function(message) {
		return function(dispatch) {
			dispatch(message);
		};
	},

	refreshAllAddressbooks: function() {
		return this.loadAllAddressbooks();
	},

	getAddressbookByType: function(type) {
		return function(dispatch) {
			if (type === 'globalPersonal') {
				return this.loadGlobalPersonalAddressbook();
			} else {
				throw new Error(`Unsupported addressbook type: ${type}. Only 'globalPersonal' is supported.`);
			}
		}.bind(this);
	}
}); 